<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dKuiKy/tc-custom/9781507162675.jpg?1680370566981" alt="This image is the cover for the book A Pezzi: Parte Otto"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Pezzi: Parte Otto
      </h1>
      <p class="bookDescription body article font2">
        <b>Ottavo libro della saga "Alpha billionaire romance".</b><br/> Piper Gravatt pensava di avere una vita perfetta. Si era appena laureata al college e stava per sposare l'uomo dei suoi sogni. A quel punto, tutto si è trasformato in un inferno.<br/> Circostanze oscure l'hanno condotta verso desideri ancora più oscuri, e c'era solo un modo per seppellire il suo dolore. Il suo nuovo motto: Mai donarsi completamente.<br/> La vita è desolata fatta eccezione per i desideri. E c'è un unico posto in cui Piper può ottenere ciò di cui ha bisogno per sopravvivere: il Club Fet, dove gli uomini sono affascinanti e i gesti del piacere non sono convenzionali.<br/> Tuttavia, essere discreti non sempre funziona, specialmente quando la strada conduce nei posti sbagliati. Uomini potenti si annidano nelle tenebre e uno in particolare è determinato a distruggere tutto ciò che Piper è.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sky Corgan, Bianca Rita Cataldi
      </h2>
      
      <p class="authorDescription body article">Sky Corgan è l'autrice best seller negli Stati Uniti della serie The Billionaires Club. Vive in un piccolo paesino sperduto vicino San Antonio, Texas. Quando non batte sulla tastiera il suo prossimo, infuocato romanzo d'amore, è impegnata a progettare vacanze future,<br/> In origine autrice di horror, ha visto le scene di sesso e le storie d'amore iniziare magicamente a infilarsi nel suo lavoro, così ha deciso di deviare verso il romance. Ora ama scrivere storie che fanno battere il cuore e risvegliare i desideri nascosti.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?286d832e